import { z } from 'zod';

const HANDLE_REGEX = /[^a-z0-9-_]/;

export const CreateOrgDataSchema = z.object({
  email: z.string().nonempty('Required field').email(),
  firstName: z.string().min(1, 'First name must contain at least 1 character'),
  lastName: z.string().min(1, 'Last name must contain at least 1 character'),
  countryCode: z
    .string()
    .length(2, 'Please choose the country where your organisation is located')
    .nonempty('Required field'),
  organisationDetail: z.object(
    {
      orgName: z.string().nonempty('Required field'),
      orgAddress: z.string().nullable().optional(),
      dunsId: z.string().nullable().optional(),
      isCreated: z.boolean(),
    },
    {
      invalid_type_error: 'Required field',
      required_error: 'Required field',
    },
  ),
  organisationHandle: z
    .string()
    .min(3, 'Organisation handle must contain atleast 3 charaters')
    .refine((v) => !HANDLE_REGEX.test(v), 'Handle must be lowercase alphanumeric'),
});

export type CreateOrgDataType = z.infer<typeof CreateOrgDataSchema>;
